
import search from './modules/search';
import analyse from './modules/analyse';

export default {
  search,
  analyse
}